<template>
    <div
        v-if="averageRating && totalElements"
        class="base-review-widget"
    >
        <div class="base-review-widget__rating">
            {{ averageRating }}
        </div>

        <div class="base-review-widget__stars">
            <BaseReviewStars :rating="averageRating" />
        </div>

        <span class="base-review-widget__title">{{ $t('social-proofing.title') }}</span>
        <p class="base-review-widget__description">
            {{ $t('social-proofing.description1') }} <strong>{{ $t('social-proofing.description2', { totalElements }) }}</strong> {{ $t('social-proofing.description3') }}
        </p>
    </div>
</template>

<script setup>
import BaseReviewStars from './BaseReviewStars.vue';

const route = useRoute();
const { getAverageRating } = useReviews();

const { averageRating, totalElements } = await getAverageRating(route.params.slug);
</script>

<style lang="less">
.base-review-widget {
    width: 13rem;
    margin: 0 auto;
    text-align: center;
}

.base-review-widget__rating {
    .typography-h1();
}

.base-review-widget__title {
    .typography-text();
}

.base-review-widget__description {
    padding-top: .25rem;
    font-size: 0.75rem;
    font-weight: var(--font-weight-primary-normal);
    line-height: 1.05rem;
}
</style>
